// ============ CONTEÚDO DO LIVRO "O CORAÇÃO DE TODAS AS COISAS" ============
// Dados definitivos para a página de resultado do teste

// ====== 1. TENSÃO QUE TE MOVE (para combinações duais) ======
// Mapeado pela chave do arquétipo dual
export const tensaoQueTeMove = {
  encontro: {
    // Amante + Peregrino
    texto: 'Você cuida dos outros com a mesma intensidade com que foge de si mesmo. O movimento é sua forma de não precisar de ninguém.'
  },
  poeta: {
    // Amante + Alquimista
    texto: 'Você transforma a dor alheia em beleza, mas raramente permite que alguém transforme a sua.'
  },
  curador: {
    // Amante + Guardião
    texto: 'Você protege com tanto cuidado que esquece de deixar espaço para ser protegido também.'
  },
  visionario: {
    // Peregrino + Alquimista
    texto: 'Você busca sem parar porque acredita que a transformação está sempre um passo à frente — nunca aqui, nunca agora.'
  },
  guerreiro: {
    // Peregrino + Guardião
    texto: 'Você quer ir embora e ficar ao mesmo tempo. Essa é sua guerra mais silenciosa.'
  },
  guardiao_sabio: {
    // Guardião + Alquimista
    texto: 'Você quer construir estruturas que durem e dissolver tudo que está parado. Essas forças brigam dentro de você toda vez que precisa tomar uma decisão.'
  },
  coracao_inteiro: {
    texto: 'Você aprendeu a habitar todas as estações. O desafio agora não é integrar — é escolher, porque quem pode tudo precisa aprender a querer algo.'
  },
  // Triplas — usam a tensão das duas raízes mais fortes
  profeta: {
    texto: 'Você busca sem parar porque acredita que a transformação está sempre um passo à frente — nunca aqui, nunca agora.'
  },
  construtor: {
    texto: 'Você quer ir embora e ficar ao mesmo tempo. Essa é sua guerra mais silenciosa.'
  },
  companheiro: {
    texto: 'Você cuida dos outros com a mesma intensidade com que foge de si mesmo. O movimento é sua forma de não precisar de ninguém.'
  },
  sabio_compassivo: {
    texto: 'Você protege com tanto cuidado que esquece de deixar espaço para ser protegido também.'
  }
};

// ====== 2. PERGUNTA CLÍNICA CENTRAL ======
// Mapeado pela chave do arquétipo dominante (com fallbacks para raízes)
export const perguntaClinica = {
  curador: 'Quando foi a última vez que você pediu ajuda sem sentir que estava incomodando?',
  amante: 'Quando foi a última vez que você pediu ajuda sem sentir que estava incomodando?',
  peregrino: 'O que você estaria disposto a encontrar se parasse de se mover por um dia inteiro?',
  guardiao: 'O que você está protegendo que talvez já não precise mais de proteção?',
  alquimista: 'Você consegue nomear algo que transformou em você — não nos outros — nos últimos seis meses?',
  sabio_compassivo: 'Quando foi a última vez que você se permitiu não entender alguma coisa?',
  coracao_inteiro: 'Se todas as estações já estão em você, o que ainda está esperando permissão para ser?',
  // Fallbacks para duals/triples sem pergunta específica
  visionario: 'Você consegue nomear algo que transformou em você — não nos outros — nos últimos seis meses?',
  encontro: 'O que você estaria disposto a encontrar se parasse de se mover por um dia inteiro?',
  guerreiro: 'O que você está protegendo que talvez já não precise mais de proteção?',
  guardiao_sabio: 'O que você está protegendo que talvez já não precise mais de proteção?',
  poeta: 'Você consegue nomear algo que transformou em você — não nos outros — nos últimos seis meses?',
  profeta: 'Você consegue nomear algo que transformou em você — não nos outros — nos últimos seis meses?',
  construtor: 'O que você estaria disposto a encontrar se parasse de se mover por um dia inteiro?',
  companheiro: 'Quando foi a última vez que você pediu ajuda sem sentir que estava incomodando?'
};

// ====== 3. DEFESA CARACTERÍSTICA — "O que você evita sentir" ======
export const defesaCaracteristica = {
  curador: 'O Curador cuida compulsivamente para não precisar de cuidado. Enquanto está ocupado sendo necessário para alguém, não precisa enfrentar sua própria vulnerabilidade. O cuidado é real — mas também é uma defesa.',
  amante: 'O Curador cuida compulsivamente para não precisar de cuidado. Enquanto está ocupado sendo necessário para alguém, não precisa enfrentar sua própria vulnerabilidade. O cuidado é real — mas também é uma defesa.',
  peregrino: 'O Peregrino se move para não chegar. Cada nova jornada adia o momento de perguntar: e se eu chegar — e ainda assim não me sentir inteiro?',
  guardiao: 'O Guardião constrói estruturas para não sentir o caos. O controle é real — mas por baixo dele costuma haver um medo antigo de que, sem a estrutura, tudo desmorona — incluindo ele mesmo.',
  alquimista: 'O Alquimista transforma para não parar. Enquanto está criando sentido para a dor, não precisa simplesmente sentir a dor. A transmutação é um dom — e às vezes uma fuga.',
  coracao_inteiro: 'Quem integra tudo pode usar a integração como escudo — parecendo completo para não precisar ser visto em falta.',
  // Fallbacks para duals/triples
  visionario: 'O Alquimista transforma para não parar. Enquanto está criando sentido para a dor, não precisa simplesmente sentir a dor. A transmutação é um dom — e às vezes uma fuga.',
  encontro: 'O Peregrino se move para não chegar. Cada nova jornada adia o momento de perguntar: e se eu chegar — e ainda assim não me sentir inteiro?',
  guerreiro: 'O Guardião constrói estruturas para não sentir o caos. O controle é real — mas por baixo dele costuma haver um medo antigo de que, sem a estrutura, tudo desmorona — incluindo ele mesmo.',
  guardiao_sabio: 'O Guardião constrói estruturas para não sentir o caos. O controle é real — mas por baixo dele costuma haver um medo antigo de que, sem a estrutura, tudo desmorona — incluindo ele mesmo.',
  poeta: 'O Alquimista transforma para não parar. Enquanto está criando sentido para a dor, não precisa simplesmente sentir a dor. A transmutação é um dom — e às vezes uma fuga.',
  profeta: 'O Alquimista transforma para não parar. Enquanto está criando sentido para a dor, não precisa simplesmente sentir a dor. A transmutação é um dom — e às vezes uma fuga.',
  construtor: 'O Peregrino se move para não chegar. Cada nova jornada adia o momento de perguntar: e se eu chegar — e ainda assim não me sentir inteiro?',
  companheiro: 'O Peregrino se move para não chegar. Cada nova jornada adia o momento de perguntar: e se eu chegar — e ainda assim não me sentir inteiro?',
  sabio_compassivo: 'O Curador cuida compulsivamente para não precisar de cuidado. Enquanto está ocupado sendo necessário para alguém, não precisa enfrentar sua própria vulnerabilidade. O cuidado é real — mas também é uma defesa.'
};

// ====== 4. CAPÍTULOS DO LIVRO COM CONTEÚDO REAL ======
// Lookup por título do capítulo → conteúdo enriquecido
export const capitulosEnriquecidos = {
  'Capítulo 1 — Para você viver mais': {
    parte: 'Parte 2 — Cada Coração é um Universo',
    dominio: 'Alquimista / Guardião',
    abertura: 'Há coisas que só percebemos tarde demais — e este capítulo existe para que você não precise esperar.',
    promessa: 'Este capítulo vai te ajudar a reconhecer o quanto você é necessário — de um jeito que talvez ainda não consiga medir.',
    link: 'https://ocoracaodetodasascoisas.com'
  },
  'Capítulo 2 — A Perfeição Quando as Flores Caem': {
    parte: 'Parte 2 — Cada Coração é um Universo',
    dominio: 'Alquimista',
    abertura: 'A perfeição não é algo a ser buscado — ela já acontece, no ciclo que você insiste em resistir.',
    promessa: 'Este capítulo vai te mostrar o que se libera quando você para de exigir que as coisas sejam diferentes do que são.',
    link: 'https://ocoracaodetodasascoisas.com'
  },
  'Capítulo 3 — Águas Cristalinas': {
    parte: 'Parte 2 — Cada Coração é um Universo',
    dominio: 'Peregrino',
    abertura: 'O que você busca lá fora já existe dentro de você — quieto, esperando que você pare.',
    promessa: 'Este capítulo vai te devolver à simplicidade do caminho — e ao que há de sagrado nos passos pequenos.',
    link: 'https://ocoracaodetodasascoisas.com'
  },
  'Capítulo 4 — O Barco Vazio': {
    parte: 'Parte 2 — Cada Coração é um Universo',
    dominio: 'Coração Inteiro',
    abertura: 'Desapegar não é perder — é reconhecer que o essencial sempre permanece, mesmo quando tudo passa.',
    promessa: 'Este capítulo vai te ajudar a soltar o que você carrega sem perceber — e encontrar o que não pode ser levado embora.',
    link: 'https://ocoracaodetodasascoisas.com'
  },
  'Capítulo 5 — Aquele que Permanece': {
    parte: 'Parte 2 — Cada Coração é um Universo',
    dominio: 'Guardião',
    abertura: 'Fui incompreendido, principalmente por mim mesmo — e foi daí que nasceu tudo que sou.',
    promessa: 'Este capítulo vai te mostrar que a firmeza não vem da ausência de dor, mas de aprender a continuar mesmo dentro dela.',
    link: 'https://ocoracaodetodasascoisas.com'
  },
  'Capítulo 6 — As Parábolas Gêmeas': {
    parte: 'Parte 2 — Cada Coração é um Universo',
    dominio: 'Transição / Alquimista',
    abertura: 'O progresso começa quando você para de ter certeza de quem é.',
    promessa: 'Este capítulo vai te convidar a soltar a identidade que construiu — e descobrir o que existe além dela.',
    link: 'https://ocoracaodetodasascoisas.com'
  },
  'Capítulo 1 — O Peso Insustentável do Ser': {
    parte: 'Parte 3 — O Chamado do Coração',
    dominio: 'Curador',
    abertura: 'A depressão como conheço também sorri. Ela se importa e acorda cedo.',
    promessa: 'Este capítulo vai te encontrar exatamente onde você está — sem exigir que você esteja bem.',
    link: 'https://ocoracaodetodasascoisas.com'
  },
  'Capítulo 2 — O Limiar da Escolha': {
    parte: 'Parte 3 — O Chamado do Coração',
    dominio: 'Guerreiro / Peregrino',
    abertura: 'Ninguém está certo. E foi só quando entendi isso que a liberdade começou.',
    promessa: 'Este capítulo vai te mostrar que escolher não é sobre acertar — é sobre ter coragem de começar.',
    link: 'https://ocoracaodetodasascoisas.com'
  },
  'Capítulo 3 — O Coração Amanhece': {
    parte: 'Parte 3 — O Chamado do Coração',
    dominio: 'Curador',
    abertura: 'Pela primeira vez, chorei não de dor — mas de alívio. Alguém finalmente me compreendeu.',
    promessa: 'Este capítulo vai integrar o que em você ainda está partido — não consertando, mas acolhendo.',
    link: 'https://ocoracaodetodasascoisas.com'
  },
  'Capítulo 4 — A Casa do Tempo': {
    parte: 'Parte 3 — O Chamado do Coração',
    dominio: 'Guardião Sábio',
    abertura: 'O coração é a casa do tempo — e nenhum instante vivido de verdade é em vão.',
    promessa: 'Este capítulo vai te ensinar a desacelerar sem culpa — e encontrar beleza no que insiste em permanecer.',
    link: 'https://ocoracaodetodasascoisas.com'
  },
  'Capítulo 5 — O Jardim do Perdão': {
    parte: 'Parte 3 — O Chamado do Coração',
    dominio: 'Alquimista',
    abertura: 'Perdoar não é negar a dor — é parar de permitir que o que fizeram com você continue te definindo.',
    promessa: 'Este capítulo vai te mostrar um lugar onde não existe peso — apenas espaço para respirar.',
    link: 'https://ocoracaodetodasascoisas.com'
  },
  'Capítulo 6 — Lembre-se de Mim': {
    parte: 'Parte 3 — O Chamado do Coração',
    dominio: 'Coração Inteiro',
    abertura: 'Sou apenas um ser humano muito, muito comum — e isso foi o suficiente para escrever este livro.',
    promessa: 'Este capítulo é uma despedida e um começo. Vai te lembrar de que nada do que você viveu foi em vão.',
    link: 'https://ocoracaodetodasascoisas.com'
  },
  // Variações de capitalização que podem existir no mapData.js
  'Capítulo 5 — Aquele que permanece': {
    parte: 'Parte 2 — Cada Coração é um Universo',
    dominio: 'Guardião',
    abertura: 'Fui incompreendido, principalmente por mim mesmo — e foi daí que nasceu tudo que sou.',
    promessa: 'Este capítulo vai te mostrar que a firmeza não vem da ausência de dor, mas de aprender a continuar mesmo dentro dela.',
    link: 'https://ocoracaodetodasascoisas.com'
  },
  'Capítulo 6 — Lembre-se de mim': {
    parte: 'Parte 3 — O Chamado do Coração',
    dominio: 'Coração Inteiro',
    abertura: 'Sou apenas um ser humano muito, muito comum — e isso foi o suficiente para escrever este livro.',
    promessa: 'Este capítulo é uma despedida e um começo. Vai te lembrar de que nada do que você viveu foi em vão.',
    link: 'https://ocoracaodetodasascoisas.com'
  },
  'Capítulo 6 — Lembre-se de Mim': {
    parte: 'Parte 3 — O Chamado do Coração',
    dominio: 'Coração Inteiro',
    abertura: 'Sou apenas um ser humano muito, muito comum — e isso foi o suficiente para escrever este livro.',
    promessa: 'Este capítulo é uma despedida e um começo. Vai te lembrar de que nada do que você viveu foi em vão.',
    link: 'https://ocoracaodetodasascoisas.com'
  },
  'Capítulo 5 — Aquele que Permanece': {
    parte: 'Parte 2 — Cada Coração é um Universo',
    dominio: 'Guardião',
    abertura: 'Fui incompreendido, principalmente por mim mesmo — e foi daí que nasceu tudo que sou.',
    promessa: 'Este capítulo vai te mostrar que a firmeza não vem da ausência de dor, mas de aprender a continuar mesmo dentro dela.',
    link: 'https://ocoracaodetodasascoisas.com'
  },
  'Capítulo 2 — A perfeição quando as flores caem': {
    parte: 'Parte 2 — Cada Coração é um Universo',
    dominio: 'Alquimista',
    abertura: 'A perfeição não é algo a ser buscado — ela já acontece, no ciclo que você insiste em resistir.',
    promessa: 'Este capítulo vai te mostrar o que se libera quando você para de exigir que as coisas sejam diferentes do que são.',
    link: 'https://ocoracaodetodasascoisas.com'
  }
};

// Helper: busca conteúdo enriquecido por título do capítulo (case-insensitive match)
export const getChapterContent = (tituloCapitulo) => {
  // Tenta match exato primeiro
  if (capitulosEnriquecidos[tituloCapitulo]) {
    return capitulosEnriquecidos[tituloCapitulo];
  }
  // Tenta match por inclusão de palavras-chave
  const titleLower = tituloCapitulo.toLowerCase();
  for (const [key, value] of Object.entries(capitulosEnriquecidos)) {
    if (key.toLowerCase() === titleLower) return value;
  }
  return null;
};

// ====== 5. PALETA DE CORES OFICIAL ======
export const PALETA_OFICIAL = {
  peregrino: { hex: '#1B4FD8', label: 'Azul Cobalto' },
  guardiao: { hex: '#C084FC', label: 'Lavanda' },
  alquimista: { hex: '#F59E0B', label: 'Dourado' },
  amante: { hex: '#EC4899', label: 'Rosa/Magenta' }
};
